import { render, staticRenderFns } from "./StaffAdd.vue?vue&type=template&id=2c1cde66&scoped=true&"
import script from "./StaffAdd.vue?vue&type=script&lang=js&"
export * from "./StaffAdd.vue?vue&type=script&lang=js&"
import style0 from "./StaffAdd.vue?vue&type=style&index=0&id=2c1cde66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1cde66",
  null
  
)

export default component.exports